let jumpStartY = null;

function computeJumpStartY(jump) {
  const wasSticky = jump.classList.contains('sticky--header');
  if (wasSticky) jump.classList.remove('sticky--header');

  const y = jump.getBoundingClientRect().top + window.scrollY;

  if (wasSticky) jump.classList.add('sticky--header');
  return y;
}

function normalizePath(path) {
  return path.replace(/\/+$/, '') || '/';
}

function getTargetSection(link) {
  const href = link?.getAttribute('href');

  if (!href) {
    return null;
  }

  try {
    const url = new URL(href, window.location.href);
    const isSamePage =
      url.origin === window.location.origin &&
      normalizePath(url.pathname) === normalizePath(window.location.pathname) &&
      url.search === window.location.search;

    if (!isSamePage || !url.hash) {
      return null;
    }

    return document.getElementById(decodeURIComponent(url.hash.slice(1)));
  } catch {
    return null;
  }
}

function updateActiveLink({ jump, headerHeight }) {
  const buttons = [...jump.querySelectorAll('.lnip-protege-jump-nav__link')];
  const jumpHeight = jump.classList.contains('sticky--header')
    ? Math.ceil(jump.getBoundingClientRect().height)
    : 0;

  const activationOffset = 80;
  const activeLineY = window.scrollY + headerHeight + jumpHeight + activationOffset;

  const sectionLinks = [];

  buttons.forEach((button) => {
    const link = button.querySelector('.wp-block-button__link');

    button.classList.remove('active');

    if (link) {
      link.removeAttribute('aria-current');
    }

    const target = getTargetSection(link);

    if (!target) {
      return;
    }

    sectionLinks.push({
      button,
      link,
      top: target.getBoundingClientRect().top + window.scrollY,
    });
  });

  const activeLink = sectionLinks
    .sort((first, second) => first.top - second.top)
    .reduce(
      (current, entry) => (entry.top <= activeLineY ? entry : current),
      null
    );

  if (!activeLink) {
    return;
  }

  activeLink.button.classList.add('active');
  activeLink.link.setAttribute('aria-current', 'location');
}

function observe({ recompute = false } = {}) {
  const topBanner = document.querySelector('.top-banner');
  const header = document.querySelector('.site--header');
  const jump = document.querySelector('.lnip-protege-jump-nav-block');

  if (!jump) return;

  const headerHeight = Math.ceil(header?.getBoundingClientRect().height || 0);
  const isStickyEnabled = jump.classList.contains('sticky--true');
  let topBannerHeight = 0;
  if (topBanner) {
    topBannerHeight = Math.ceil(topBanner.getBoundingClientRect().height);
  }
  
  if (isStickyEnabled) {
    if (recompute || jumpStartY === null) {
      jumpStartY = computeJumpStartY(jump);
    }

    const shouldStick = window.scrollY + headerHeight + 2 >= jumpStartY;

    if (shouldStick) {
      const offset = headerHeight + topBannerHeight - 2;
      jump.classList.add('sticky--header');
      jump.style.setProperty('--jump-offset', `${offset}px`);
    } else {
      jump.classList.remove('sticky--header');
      jump.style.removeProperty('--jump-offset');
    }
  } else {
    jump.classList.remove('sticky--header');
    jump.style.removeProperty('--jump-offset');
  }

  updateActiveLink({ jump, headerHeight });
}

let ticking = false;
function onScroll() {
  if (ticking) return;
  ticking = true;
  requestAnimationFrame(() => {
    observe();
    ticking = false;
  });
}

window.addEventListener('scroll', onScroll, { passive: true });
window.addEventListener('resize', () => observe({ recompute: true }));
document.addEventListener('DOMContentLoaded', () => observe({ recompute: true }));
window.addEventListener('load', () => observe({ recompute: true }));
window.addEventListener('hashchange', () => observe({ recompute: true }));
